import React, { ReactElement } from 'react';
import useStyles from './Cell.styles';

export type CellIconProps = {
  children: ReactElement;
};

export const CellIcon: React.FC<CellIconProps> = ({ children }) => {
  const s = useStyles();

  return React.cloneElement(children, { style: [s.icon] });
};
